"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_table_1 = require("@patternfly/react-table");
var react_1 = __importStar(require("react"));
var react_core_1 = require("@patternfly/react-core");
var utilities_1 = require("../utilities");
function SchnurTable(props) {
    var _a;
    var _b = (0, react_1.useState)([]), normalizedColumns = _b[0], setNormalizedColumns = _b[1];
    var _c = react_1.default.useState(1), page = _c[0], setPage = _c[1];
    var _d = react_1.default.useState((_a = props.defaultPageSize) !== null && _a !== void 0 ? _a : 10), perPage = _d[0], setPerPage = _d[1];
    var _e = react_1.default.useState(undefined), activeSortIndex = _e[0], setActiveSortIndex = _e[1];
    var _f = react_1.default.useState(undefined), activeSortDirection = _f[0], setActiveSortDirection = _f[1];
    var mapIndexToColumn = new Map();
    (0, react_1.useEffect)(function () {
        setNormalizedColumns(props.columns.map(function (column) {
            var columnTitle = typeof column === 'string' ? column : column.title;
            var columnSortable = typeof column === 'string' ? false : column.sortable;
            return {
                title: (0, utilities_1.cleanupPropertyName)(String(columnTitle)),
                sortable: columnSortable,
            };
        }));
    }, [props.columns]);
    props.columns.forEach(function (column, columnIndex) {
        var columnName = typeof column === 'string' ? column : column.columnName;
        mapIndexToColumn.set(columnIndex, columnName);
    });
    var sortedData = props.data;
    if (activeSortIndex !== undefined) {
        sortedData = props.data.sort(function (a, b) {
            var aValue = a[mapIndexToColumn.get(activeSortIndex)];
            var bValue = b[mapIndexToColumn.get(activeSortIndex)];
            if (typeof aValue === 'number') {
                if (activeSortDirection === 'asc') {
                    return aValue - bValue;
                }
                return bValue - aValue;
            }
            else if (typeof aValue === 'string') {
                if (activeSortDirection === 'asc') {
                    return aValue.localeCompare(bValue);
                }
                return bValue.localeCompare(aValue);
            }
            else if (typeof aValue === 'boolean') {
                if (activeSortDirection === 'asc') {
                    return aValue ? 1 : -1;
                }
                return aValue ? -1 : 1;
            }
            return 0;
        });
    }
    if (props.filter !== undefined && props.filter !== '') {
        var finalFilter_1 = props.filter.toLowerCase();
        sortedData = sortedData.filter(function (row) {
            for (var _i = 0, _a = props.columns; _i < _a.length; _i++) {
                var column = _a[_i];
                var columnName = typeof column === 'string' ? column : column.columnName;
                var data = row[columnName];
                if (String(data).toLowerCase().includes(finalFilter_1)) {
                    return true;
                }
            }
            return false;
        });
    }
    var getSortParams = function (columnIndex, _column) { return ({
        sortBy: {
            index: activeSortIndex,
            direction: activeSortDirection,
            defaultDirection: 'asc',
        },
        onSort: function (_event, index, direction) {
            setActiveSortIndex(index);
            setActiveSortDirection(direction);
        },
        columnIndex: columnIndex,
    }); };
    var defaultActions = function (row) {
        var actions = [];
        var _loop_1 = function (action) {
            actions.push({
                title: action.name,
                onClick: function () {
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                    action.callback(row);
                },
            });
        };
        for (var _i = 0, _a = props.actions || []; _i < _a.length; _i++) {
            var action = _a[_i];
            _loop_1(action);
        }
        return actions;
    };
    var onSetPage = function (_event, newPage) {
        setPage(newPage);
    };
    var onPerPageSelect = function (_event, newPerPage, newPage) {
        setPerPage(newPerPage);
        setPage(newPage);
    };
    var startIndex = (page - 1) * perPage;
    var endIndex = startIndex + perPage;
    var currentPagedData = sortedData.slice(startIndex, endIndex);
    return ((0, jsx_runtime_1.jsx)(react_1.default.Fragment, { children: props.loading === true ? ((0, jsx_runtime_1.jsx)(react_core_1.Flex, __assign({ justifyContent: { default: 'justifyContentCenter' } }, { children: (0, jsx_runtime_1.jsx)(react_core_1.FlexItem, { children: (0, jsx_runtime_1.jsx)(react_core_1.Spinner, { isSVG: true, diameter: '40px' }) }) }))) : ((0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [(0, jsx_runtime_1.jsxs)(react_table_1.TableComposable, __assign({ "aria-label": props.ariaLabel }, { children: [props.caption && (0, jsx_runtime_1.jsx)(react_table_1.Caption, { children: props.caption }), (0, jsx_runtime_1.jsx)(react_table_1.Thead, { children: (0, jsx_runtime_1.jsxs)(react_table_1.Tr, { children: [normalizedColumns.map(function (column, index) { return ((0, jsx_runtime_1.jsx)(react_table_1.Th, __assign({ sort: column.sortable
                                            ? getSortParams(index, column.title)
                                            : undefined }, { children: String(column.title) }), index)); }), props.actions ? (0, jsx_runtime_1.jsx)(react_table_1.Td, { children: "Actions" }, "actions") : null] }) }), (0, jsx_runtime_1.jsx)(react_table_1.Tbody, { children: currentPagedData.map(function (row, rowIndex) {
                                return ((0, jsx_runtime_1.jsxs)(react_table_1.Tr, { children: [props.columns.map(function (column, columnIndex) {
                                            var columnName = typeof column === 'string'
                                                ? column
                                                : column.columnName;
                                            var data = row[columnName];
                                            if (typeof column === 'object' &&
                                                'customAccessor' in column &&
                                                column.customAccessor !== undefined) {
                                                data = column.customAccessor(row);
                                            }
                                            var outData = '';
                                            if (typeof data === 'boolean') {
                                                outData = data ? 'Yes' : 'No';
                                            }
                                            else {
                                                outData = String(data);
                                            }
                                            if (outData === undefined ||
                                                outData === null ||
                                                outData === 'null' ||
                                                outData === 'undefined') {
                                                outData = '';
                                            }
                                            return ((0, jsx_runtime_1.jsx)(react_table_1.Td, __assign({ dataLabel: String(column) }, { children: outData === null || outData === undefined
                                                    ? 'a'
                                                    : outData }), "".concat(rowIndex, "-").concat(columnIndex)));
                                        }), props.actions ? ((0, jsx_runtime_1.jsx)(react_table_1.Td, { children: (0, jsx_runtime_1.jsx)(react_table_1.ActionsColumn, { items: defaultActions(row) }) })) : null] }, "abc-".concat(rowIndex)));
                            }) })] })), (0, jsx_runtime_1.jsx)(react_core_1.Pagination, { perPageComponent: "button", itemCount: sortedData.length, widgetId: "table-pagination-bottom", perPage: perPage, page: page, variant: react_core_1.PaginationVariant.bottom, onSetPage: onSetPage, onPerPageSelect: onPerPageSelect })] })) }));
}
exports.default = SchnurTable;
